
document.addEventListener('DOMContentLoaded', function() {
  // Handle scroll-to-first-section functionality for image reviews section
  const reviewButtons = document.querySelectorAll('.claim-button[data-scroll-to-first-section]');
  
  reviewButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      console.log('🎯 Image Reviews: Scrolling to first section...');
      
      // Find the first section on the page (excluding header/navigation)
      const selectors = [
        // Most common first section patterns
        'main section:first-of-type',
        '.main-content section:first-of-type',
        '.page-content section:first-of-type',
        
        // Shopify section patterns
        '.shopify-section:not([data-section-type="header"]):not([data-section-type="announcement-bar"])',
        'section.shopify-section:not([data-section-type="header"])',
        
        // General section patterns
        'main > *:first-child',
        '.content section:first-of-type',
        'section:not(header):not([role="banner"])',
        
        // Fallback to any section
        'section:first-of-type',
        '[data-section-type]:not([data-section-type="header"])',
        
        // Last resort - any content element
        'main > div:first-child',
        '.main > *:first-child'
      ];
      
      let targetElement = null;
      let usedSelector = '';
      
      for (const selector of selectors) {
        try {
          const elements = document.querySelectorAll(selector);
          if (elements.length > 0) {
            targetElement = elements[0];
            usedSelector = selector;
            console.log(`✅ Found target using selector: ${usedSelector}`, targetElement);
            break;
          }
        } catch (error) {
          console.warn(`❌ Invalid selector: ${selector}`, error);
        }
      }
      
      if (targetElement) {
        // Calculate offset for fixed headers
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;
        const stickyHeader = document.querySelector('.sticky-header, .header-sticky, [style*="position: fixed"]')?.offsetHeight || 0;
        const adminBarHeight = document.querySelector('#admin_bar_iframe, .admin-bar')?.offsetHeight || 0;
        const announcementBar = document.querySelector('.announcement-bar, .promo-bar')?.offsetHeight || 0;
        
        const offset = Math.max(headerHeight, stickyHeader) + adminBarHeight + announcementBar + 20;
        
        const elementPosition = targetElement.offsetTop;
        const offsetPosition = elementPosition - offset;
        
        window.scrollTo({
          top: Math.max(0, offsetPosition),
          behavior: 'smooth'
        });
        
        console.log(`✅ Image Reviews: Scrolled to first section using selector: ${usedSelector}`);
        
        // Optional: Add visual highlight to show successful targeting
        targetElement.style.transition = 'all 0.3s ease';
        targetElement.style.transform = 'scale(1.01)';
        setTimeout(() => {
          targetElement.style.transform = 'scale(1)';
        }, 300);
        
      } else {
        console.warn('⚠️ Image Reviews: No first section found, falling back to scroll to top');
        // Fallback: scroll to top if no target found
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  });
});
